// Proton renders 16px line icons (size 4) at a 1px stroke. Lucide's glyphs at
// 16px with strokeWidth 1.5 land on the same visual weight (1.5 × 16/24 = 1px),
// without shipping Proton's GPL-licensed icon set to public pages.
import type { LucideIcon, LucideProps } from "lucide-react";
import clsx from "clsx";

const PX: Record<number, number> = { 3: 12, 3.5: 14, 4: 16, 5: 20, 6: 24, 7: 28, 8: 32, 9: 36, 10: 40, 12: 48 };

export function Icon({
  as: I, size = 4, className, strokeWidth = 1.5, ...rest
}: { as: LucideIcon; size?: number } & Omit<LucideProps, "size" | "ref">) {
  const px = PX[size] ?? size * 4;
  return <I size={px} strokeWidth={strokeWidth} className={clsx("shrink-0", className)} aria-hidden="true" {...rest} />;
}
